import { Box, Typography } from '@mui/material'
import { LocalFireDepartment as FireIcon } from '@mui/icons-material'
import { useTranslation } from 'react-i18next'
import type { HeatmapPoint } from '@/types/dashboard'
import type { WidgetProps } from './WidgetProps'
import { ActivityWidgetContent } from './ActivityWidgetContent'

/**
 * Серия дней ученика и его собственная активность. При высоте 2+ рядов
 * под графиком появляется таймлайн своих событий (без имени автора).
 */
export function StreakWidget({ payload, rows }: WidgetProps) {
  const { t } = useTranslation()
  const current = Number(payload.current ?? 0)
  const longest = Number(payload.longest ?? 0)
  const days = (payload.days ?? []) as HeatmapPoint[]
  const from = typeof payload.from === 'string' ? payload.from : ''
  const to = typeof payload.to === 'string' ? payload.to : ''

  const header = (
    <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, mb: 1 }}>
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
        <FireIcon color={current > 0 ? 'warning' : 'disabled'} />
        <Typography variant="h5" fontWeight={700}>
          {current}
        </Typography>
        <Typography variant="caption" color="text.secondary">
          {t('dashboard.widgets.streak.days')}
        </Typography>
      </Box>
      <Box>
        <Typography variant="caption" color="text.secondary" display="block">
          {t('dashboard.widgets.streak.current')}
        </Typography>
        <Typography variant="caption" color="text.secondary">
          {t('dashboard.widgets.streak.longest')}: <b>{longest}</b>
        </Typography>
      </Box>
    </Box>
  )

  return (
    <ActivityWidgetContent from={from} to={to} days={days} rows={rows} header={header} />
  )
}
